import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ConfirmSignup from "./pages/ConfirmSignup";
import NotFound from "./pages/NotFound";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ResetExpired from './pages/ResetExpired';
import Subscribe from "./pages/Subscribe";
import Welcome from "./pages/Welcome";
import ConfirmError from "./pages/ConfirmError";
import AboutUs from "./pages/AboutUs";
import HomilyPreview from "./pages/HomilyPreview";
import BlogPreview from "./pages/BlogPreview";
import EmailHomilyUnsubscribe from './pages/EmailHomilyUnsubscribe';
// import HomilyUnsubscribe from "./pages/HomilyUnsubscribe"; - old file

import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./components/Dashboard";

import GlobalStyles from "./styles/GlobalStyles";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

function App() {
  // Feature flags to temporarily hide auth/subscription routes.
  const ENABLE_AUTH_ROUTES = false;
  const ENABLE_SUBSCRIPTION_ROUTES = false;
  const ENABLE_MARKETING_ROUTES = false;

  return (
    <>
      <GlobalStyles />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          {ENABLE_AUTH_ROUTES && (
            <>
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/confirm" element={<ConfirmSignup />} />
              <Route path="/confirm-error" element={<ConfirmError />} />
              <Route path="/forgot" element={<ForgotPassword />} />
              <Route path="/reset" element={<ResetPassword />} />
              <Route path="/reset-expired" element={<ResetExpired />} />
            </>
          )}
          {ENABLE_SUBSCRIPTION_ROUTES && (
            <>
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/checkout-success" element={<Welcome />} />
            </>
          )}
          {ENABLE_MARKETING_ROUTES && (
            <>
              <Route path="/homily_preview" element={<HomilyPreview />} />
              <Route path="/blog_preview" element={<BlogPreview />} />
            </>
          )}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/homily-email-unsubscribe" element={<EmailHomilyUnsubscribe />} />
          
          {/* Auth‑protected app dashboard */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch‑all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
